import { SupportedFileTypes } from '../../../components/shared/modals/fileUploadModal/constants';

export const getExtensionByContentType = (contentType: keyof typeof SupportedFileTypes) => {
  if (!(contentType in SupportedFileTypes)) {
    console.warn('Unsupported content type');
  }

  return SupportedFileTypes[contentType];
};
